// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"53497a2e","127":"08cd801e","142":"e26c6f27","161":"8512c123","234":"f5b33a8a","318":"3c0e11f6","347":"2ac6cc7e","396":"014bae2d","453":"1b09c53a","568":"314b56cb","665":"4580b332","682":"f7374528","782":"140c8d9c","830":"17861f48"}[chunkId] + ".chunk.js";
};